import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { URLSearchParams } from '@angular/http';
import { environment as config } from '../environments/environment';

const urlParams = new URLSearchParams(window.location.search.slice(1));
if(!urlParams.has('session_id')) {
  console.warn('You didn\'t provide a session_id');
}
const sessionId = urlParams.get('session_id');

@Injectable()
export class AppService {
  sessionId: string;

  constructor (private http: Http) {
    this.sessionId = sessionId;
  }

  doRequest(action, body) {
    return this.http.post(`${config.api.baseUrl}/sessions/${this.sessionId}/${action}`, JSON.stringify(body));
  }

  sendVotes(body) {
  	return this.doRequest('votes', body);
  }

  sendQuestions(body) {
    return this.doRequest('questions', body);
  }

  sendQuizz(body) {
  	return this.doRequest('quizz', body);
  }

  sendTagCloud(body) {
    return this.doRequest('tagcloud', body);
  }
}



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/app.service.ts